export const KIND_LABEL = { dish: "guide_dish", dessert: "guide_dessert", street: "guide_street" };

const VIDEO_WORD = { it: "ricetta", en: "recipe", fr: "recette", ar: "طريقة عمل" };

export const pickText = (obj, lang) => (obj && (obj[lang] || obj.en)) || "";
export const pickList = (obj, lang) => (obj && (obj[lang] || obj.en)) || [];

export function videoRecipeUrl(food, lang) {
  const name = pickText(food.name, lang);
  const q = lang === "ar" ? `${VIDEO_WORD.ar} ${name}` : `${name} ${VIDEO_WORD[lang] || VIDEO_WORD.en}`;
  return `https://www.youtube.com/results?search_query=${encodeURIComponent(q)}`;
}

export function fmtMinutes(min, t) {
  if (min < 60) return `${min} ${t("recipe_min")}`;
  const h = Math.floor(min / 60);
  const m = min % 60;
  return m ? `${h} ${t("recipe_hours")} ${m} ${t("recipe_min")}` : `${h} ${t("recipe_hours")}`;
}
